<template>
<li v-if="bullet" :class="['bulletpoint', {'is-expanded': expanded}]">
    <p @click.prevent="expanded = !expanded" class="title"><span :class="['icon', colour]">
        <template v-if="expanded">-</template><template v-else>+</template>
    </span> {{bullet.title}}</p>
    <div :style="'height: ' + height + 'px;'" class="content-holder"><div ref="content" class="content" v-html="bullet.content"></div></div>
</li>
</template>

<script>
export default {
    name        :   'ExpandableLi',
    props       :   ['bullet', 'colour'],
    data()
    {
        return {
            expanded    :   false,
            height      :   0
        }
    },
    watch       :   {
        expanded(nv, ov) {
            this.height =   nv ? $(this.$refs.content).outerHeight() : 0;
        }
    },
    mounted() {
        this.$nextTick().then(() => {
            if (this.$refs.content) {
                this.HandleContentedLinks(this.$refs.content, this)
            }
        })
    }
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/modules/elements/ExpandableLi.vue